<template>
  <div id="content">
    <div id="map-container">
    </div>

    <div id="bg" @click="ShowAndHide"></div>    <!-- 遮罩层  -->
    <div id="show" @click="ShowAndHide">        <!-- 文本层  -->
      <div style="height: 20%;" id="ppxx">
        <h4 id="pwbh"></h4>
        <h5 id="lc"></h5>
        <h5 id="ppmc"></h5>
        <h5 id="zbx"></h5>
        <h5 id="zby">:</h5>
      </div>
      
    </div>
  </div>
</template>

<script>

import MapApplication from '../../MapApplication';

export default {
  name: "MapContainer",
  data: () => ({
    path:"",
    mapID: 'test666',
    
  }),
  mounted() {
    // 初始化地图
    MapApplication.initMap(this);

  },
  destroyed() {
    // 销毁地图
    MapApplication.destroyMap()
  },
  methods:{//函数
    ShowAndHide(){//关闭遮罩层
      document.getElementById("bg").style.display ='none';
      document.getElementById("show").style.display ='none';
    }
  }
};
</script>

<style>
html,
body,
#content, 
#map-container {
  margin: 0;
  padding: 0;
  height: 100%;
  /* 2022-03-08曾琦禁用 */
  /* overflow: hidden; */
}

#bg{ 
  display: none;  
  position: absolute;  
  top: 0%;  
  left: 0%;  
  width: 100%;  
  height: 100%;  
  background-color: #ffffff;  
  z-index:1001;  
  -moz-opacity: 0.7;  
  opacity:.70;  
  filter: alpha(opacity=70);
  }
#show{
  display: none;  
  position: absolute;  
  top: 0%;  
  left: 80%;  
  width: 30%;  
  height: 100%;  
  padding: 8px;  
  border: 8px solid #E8E9F7;  
  background-color: #ffffff;  
  z-index:1002;  
  overflow: auto;
}
</style>
